import type { SelectOptionType } from '~/presentation/reports/ui/type';

import {
  OPERATOR_IS,
  OPERATOR_OPTIONS,
  SINGLE_VALUE_OPERATOR_OPTIONS,
} from '~/modules/report-analytic/constants/report-filter';
import { SelectVariantType } from '~/presentation/reports/ui/type';
import { REPORT_FILTER_INFO } from '../constants/report-filters';
import { EReportControlId } from '../types';
import { EControlType } from '../../type';

interface ICreateOperatorFilterData {
  id: string;
  label: string;
  operatorId: string;
  singleValueId: string;
  multiValueId: string;
  options: SelectOptionType[];
  type?: EControlType;
  enableCreateOption?: boolean;
  singleOperatorOnly?: boolean;
}

export function createOperatorFilter(
  data: ICreateOperatorFilterData,
  filterInfo = REPORT_FILTER_INFO,
) {
  const {
    id,
    label,
    operatorId,
    singleValueId,
    multiValueId,
    options,
    type,
    enableCreateOption,
    singleOperatorOnly,
  } = data;

  return {
    [id]: {
      id,
      uid: id,
      label,
      type: type ?? EControlType.SELECT_COMPOUND,
      dependentControls: [
        {
          id: EReportControlId.FILTER,
        },
      ],
      info: filterInfo[id],
      configs: [
        {
          id: operatorId,
          variant: SelectVariantType.ACTION_LIST,
          options: singleOperatorOnly ? SINGLE_VALUE_OPERATOR_OPTIONS : OPERATOR_OPTIONS,
          defaultValue: OPERATOR_IS,
          disableActivator: singleOperatorOnly,
        },
        {
          id: singleValueId,
          options,
          variant: SelectVariantType.ACTION_LIST,
          condition: `${operatorId} === 'is_one_of'`,
          isShowSearch: true,
          enableCreateOption,
        },
        {
          id: multiValueId,
          options,
          defaultValue: [],
          variant: SelectVariantType.CHOICE,
          condition: `${operatorId} === 'is'`,
          isShowSearch: true,
          enableCreateOption,
        },
      ],
    },
  };
}
